module.exports = __webpack_public_path__ + "resources/img/certi_iso_iec_27799.b1150d684c6bfa1e671f93675206ad26.png";